import { loanOfficerSubscriptionHooks } from 'reducers/slices/loanOfficer/subscriptionSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';

const useLoanOfficerSubscription = () => {
  const { createSubscription, subscription } = loanOfficerSubscriptionHooks.use();

  return {
    isSubscriptionCreating: useFetchStatus(subscription.creatingStatus).isPending,
    createSubscription,
  };
};

export default useLoanOfficerSubscription;



// WEBPACK FOOTER //
// ./src/reducers/hooks/loanOfficer/useSubscription.js